import { css } from "@emotion/css";
import { borderWidth, borderRadius, themeTokens } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { DataTable, DataTableRow, DataTableBody, DataTableRowColumn } from "~/primitiveComponents/dataDisplay/DataTable";
import { GreenTickIcon } from "../../ProjectStatus/GreenTickIcon";
import type { EphemeralEnvironmentsConfigurationStatus, ParentEnvironmentConfig, RunbookConfig } from "./EphemeralEnvironmentsConfigWizard";
export interface ReviewContentProps {
    configurationStatus: EphemeralEnvironmentsConfigurationStatus;
    parentEnvironmentConfig?: ParentEnvironmentConfig;
    nameTemplateConfig?: string;
    provisioningConfig?: RunbookConfig;
    deprovisioningConfig?: RunbookConfig;
    branch?: string;
}
export function ReviewContent({ configurationStatus, parentEnvironmentConfig, nameTemplateConfig, provisioningConfig, deprovisioningConfig, branch }: ReviewContentProps) {
    const styles = {
        content: css({
            border: `${borderWidth[1]} solid ${themeTokens.color.background.tertiary}`,
            borderRadius: borderRadius.small,
        }),
    };
    if (!parentEnvironmentConfig) {
        throw new Error("Missing parent environment configuration.");
    }
    if (!nameTemplateConfig) {
        throw new Error("Missing name template configuration.");
    }
    return (<div className={styles.content}>
            <DataTable>
                <DataTableBody>
                    <DataTableRow>
                        <DataTableRowColumn>Parent environment</DataTableRowColumn>
                        <DataTableRowColumn>
                            <b>{parentEnvironmentConfig?.name}</b>
                        </DataTableRowColumn>
                        {configurationStatus == "Success" && (<DataTableRowColumn>
                                <GreenTickIcon />
                            </DataTableRowColumn>)}
                    </DataTableRow>
                    <DataTableRow>
                        <DataTableRowColumn>Environment name template</DataTableRowColumn>
                        <DataTableRowColumn>
                            <b>{nameTemplateConfig}</b>
                        </DataTableRowColumn>
                        {configurationStatus == "Success" && (<DataTableRowColumn>
                                <GreenTickIcon />
                            </DataTableRowColumn>)}
                    </DataTableRow>
                    <DataTableRow>
                        <DataTableRowColumn>Provisioning runbook</DataTableRowColumn>
                        <DataTableRowColumn>
                            <b>{provisioningConfig?.name || "None selected"}</b>
                        </DataTableRowColumn>
                        {configurationStatus == "Success" && (<DataTableRowColumn>
                                <GreenTickIcon />
                            </DataTableRowColumn>)}
                    </DataTableRow>
                    <DataTableRow>
                        <DataTableRowColumn>Deprovisioning runbook</DataTableRowColumn>
                        <DataTableRowColumn>
                            <b>{deprovisioningConfig?.name || "None selected"}</b>
                        </DataTableRowColumn>
                        {configurationStatus == "Success" && (<DataTableRowColumn>
                                <GreenTickIcon />
                            </DataTableRowColumn>)}
                    </DataTableRow>
                    {!!branch && (<DataTableRow>
                            <DataTableRowColumn>Branch</DataTableRowColumn>
                            <DataTableRowColumn>
                                <b>{branch}</b>
                            </DataTableRowColumn>
                            {configurationStatus == "Success" && (<DataTableRowColumn>
                                    <GreenTickIcon />
                                </DataTableRowColumn>)}
                        </DataTableRow>)}
                </DataTableBody>
            </DataTable>
        </div>);
}
